<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        placeholder="请选择激活状态"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择配置类型"
        clearable
        size="small"
        v-model="params.moduleType"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in moduleTypes"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
      <!-- <el-button type="danger" size="small" icon="el-icon-menu" :disabled="isBatch" plain @click="openBatch">批量操作</el-button> -->
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        v-if="isBatch"
        width="55"
        fixed="left"
        align="center"
      ></el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="moduleType"
        label="配置类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.moduleType == 1"
            >AI脱衣模型</el-tag
          >
          <el-tag v-else-if="scope.row.moduleType == 2">AI视频换脸</el-tag>
          <el-tag type="warning" v-else-if="scope.row.moduleType == 3"
            >AI图片换脸</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.moduleType == 4"
            >AI图生视频</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.moduleType == 5"
            >AI绘图配置</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图" align="center" width="200" prop="cover">
        <template slot-scope="scope">
          <img-load
            :width="'80px'"
            :height="'60px'"
            :src="imgUrl + scope.row.cover"
          >
          </img-load>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="效果图" align="center" width="120">
        <template slot-scope="scope">
          <Gallery v-if="scope.row.newUrl" :list="scope.row.newUrl"></Gallery>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="激活状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">激活</el-tag>
          <el-tag v-else-if="scope.row.status == 0">未激活</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="moduleType"
        label="风格类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.moduleType == 5 ? styleObj[scope.row.styleType] : "--" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="playTime"
        label="影片时长"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.playTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="视频类型"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.type || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="价格" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.coin }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="vipCoin"
        label="vip价格"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.vipCoin }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="hotValue"
        label="热门值"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.hotValue || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="hotMark"
        label="热门标签"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.hotMark || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px 0" v-if="isBatch">
      <el-button @click="giveUpBatch" type="danger" size="mini"
        >取消批量操作</el-button
      >
      <el-button @click="openBatchDelete" type="primary" size="mini"
        >批量删除</el-button
      >
    </div>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="530px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="140px" :rules="rules" ref="form">
        <el-form-item label="配置类型" prop="moduleType" style="width: 400px">
          <el-select
            placeholder="请选择配置类型"
            clearable
            size="small"
            v-model="form.moduleType"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in moduleTypes"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title" style="width: 400px">
          <el-input type="textarea" :rows="3" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="图片:" prop="cover">
          <base-upload
            :cover="form.cover"
            :action="action"
            @successCallback="successCallback"
            :hide="true"
          ></base-upload>
        </el-form-item>
        <el-form-item
          v-if="form.moduleType == 4"
          label="效果图片:"
          prop="newUrl"
        >
          <base-upload
            :cover="form.newUrl"
            :action="action"
            @successCallback="successCallback($event, 'newUrl')"
            :hide="true"
          ></base-upload>
        </el-form-item>
        <el-form-item label="上传视频:" v-if="form.moduleType == 2">
          <!--视频分片上传-->
          <uploader
            :options="options"
            class="uploader-example"
            ref="uploader"
            @file-added="fileAdd"
            @file-success="onFileSuccess"
          >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
              <uploader-btn :attrs="attrs">上传视频</uploader-btn>
            </uploader-drop>
            <uploader-list></uploader-list>
          </uploader>
        </el-form-item>
        <el-form-item
          label="风格类型"
          prop="styleType"
          style="width: 400px"
          v-if="form.moduleType == 5"
        >
          <el-select v-model="form.styleType">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in styleList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="影片时长"
          prop="playTime"
          style="width: 400px"
          v-if="form.moduleType == 2"
        >
          <el-input v-model.number="form.playTime"></el-input>
        </el-form-item>
        <el-form-item
          label="视频类型"
          prop="type"
          style="width: 400px"
          v-if="form.moduleType == 2"
        >
          <el-input v-model="form.type"></el-input>
        </el-form-item>
        <el-form-item label="热门值" prop="hotValue" style="width: 400px">
          <el-input v-model.number="form.hotValue"></el-input>
        </el-form-item>
        <el-form-item label="热门标签" prop="hotMark" style="width: 400px">
          <el-input v-model="form.hotMark"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort" style="width: 400px">
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="coin" style="width: 400px">
          <el-input v-model.number="form.coin"></el-input>
        </el-form-item>
        <el-form-item label="vip价格" prop="vipCoin" style="width: 400px">
          <el-input v-model.number="form.vipCoin"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" style="width: 400px">
          <el-select v-model="form.status">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import local from "@/utils/localStroage.js";
import baseConfig from "@/utils/serverUrlConfig";
import PreviewVideo from "./components/preview-video";
import Gallery from "@/components/Gallery";

export default {
  components: {
    PreviewVideo,
    Gallery,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined, // 状态
        moduleType: undefined, // 类型
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请输入视频类型", trigger: "blur" }],
        styleType: [
          { required: true, message: "请选择风格类型", trigger: "blur" },
        ],
      },
      statuses: [
        {
          label: "激活",
          value: 1,
        },
        {
          label: "未激活",
          value: 0,
        },
      ],
      moduleTypes: [
        {
          label: "AI脱衣模型",
          value: 1,
        },
        {
          label: "AI视频换脸",
          value: 2,
        },
        {
          label: "AI图片换脸",
          value: 3,
        },
        {
          label: "AI图生视频",
          value: 4,
        },
        {
          label: "AI绘图配置",
          value: 5,
        },
      ],
      styleList: [
        { label: "2.5D", value: 1 },
        { label: "二次元", value: 2 },
        { label: "二次元1", value: 3 },
        { label: "写实", value: 4 },
        { label: "性感卡通", value: 5 },
        { label: "美式像素", value: 6 },
      ],
      styleObj: {
        1: "2.5D",
        2: "二次元",
        3: "二次元1",
        4: "写实",
        5: "性感卡通",
        6: "美式像素",
      },
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        title: "", // 标题
        sourceURL: "", // 视频资源地址
        status: 0, // 状态，0 未激活 1 激活
        playTime: 0, // 影片时长
        cover: "", // 封面图
        newUrl: "", // 图生视频效果图
        type: "", // 视频类型
        coin: 0, // 价格
        vipCoin: 0, // vip价格
        moduleType: undefined, // 配置类型
        hotValue: 0, // 热门值
        styleType: 1,
        hotMark: undefined, // 热门标签
        sort: 0, // 排序
      },
      isBatch: false,
      dataIds: [],
      batchUpdateDialog: false,
      batchStatus: 0,
      // 用户头像上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      imgUrl: baseConfig.imgUrl,
      attrs: {
        accept: [
          ".mp4",
          ".qlv",
          ".qsv",
          ".ogg",
          ".flv",
          ".avi",
          ".wmv",
          ".rmvb",
        ], // 接受文件类型
      },
    };
  },
  computed: {
    options() {
      return {
        target: baseConfig.baseServerUrl + "/vid/uploadDotStream", // 上传地址
        testChunks: false, // 是否开启服务器分片校验
        method: "application/json",
        headers: {
          // 额外请求头
          Authorization: local.get("userInfo")
            ? local.get("userInfo").token
            : "",
        },
        fileParameterName: "upload", // 文件名参数，默认为file
        query: this.uploadQuery, // 额外参数
        singleFile: true, // 单文件上传
        chunkSize: 2048000, // 分片大小，默认1M
        simultaneousUploads: 6,
        // 把英文时间转成中文
        parseTimeRemaining: function(timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, "年")
            .replace(/\days?/, "天")
            .replace(/\shours?/, "小时")
            .replace(/\sminutes?/, "分钟")
            .replace(/\sseconds?/, "秒");
        },
      };
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getChangeFaceModList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
          }
          if (this.isBatch) {
            this.restoreCheckedState();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 上传成功回掉
    successCallback(res, key = "cover") {
      this.form[key] = res.data.coverImg;
    },
    // 视频上传成功时回调函数
    // eslint-disable-next-line no-unused-vars
    onFileSuccess(rootFile, file, response, chunk) {
      const res = JSON.parse(response);
      this.form.sourceURL = res.data.sourceURL;
      //通知文件服务器, 上传完成
      API.uploadSuccess({ id: res.data.sourceID })
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("通知失败！");
          }
        })
        .catch(() => {
          this.$message.error("通知异常！");
        });
    },
    // 视频上传选中时
    fileAdd() {
      this.generateTaskId();
    },
    // 定义视频上传唯一标识符id
    generateTaskId() {
      const time = new Date().getTime();
      this.trackId = time;
    },
    // 视频上传额外参数
    uploadQuery(file, chunk) {
      return {
        pos: chunk.offset,
        id: String(this.trackId),
      };
    },
    // 视频查看
    checkMedia(url, type, data) {
      this.$refs.previewVideo.open(url, type, data);
    },
    // 新增标签配置
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.title = param.title;
        this.form.sourceURL = param.sourceURL;
        this.form.status = param.status;
        this.form.playTime = param.playTime;
        this.form.cover = param.cover;
        this.form.type = param.type;
        this.form.coin = param.coin;
        this.form.vipCoin = param.vipCoin;
        this.form.moduleType = param.moduleType;
        this.form.newUrl = param.newUrl;
        this.form.hotValue = param.hotValue;
        this.form.styleType = param.styleType;
        this.form.hotMark = param.hotMark;
        this.form.sort = param.sort;
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addChangeFaceMod(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updateChangeFaceMod(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delPrompt(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.title = "";
      this.form.sourceURL = "";
      this.form.status = 0;
      this.form.playTime = 0;
      this.form.cover = "";
      this.form.type = "";
      this.form.coin = 0;
      this.form.vipCoin = 0;
      this.form.moduleType = undefined;
      this.form.hotValue = 0;
      this.form.styleType = 1;
      this.form.newUrl = undefined;
      this.form.hotMark = undefined;
      this.form.sort = 0;
      this.isBatch = false;
      this.dataIds = [];
      this.batchStatus = 0;
      this.batchUpdateDialog = false;
      this.$refs.multipleTable.clearSelection();
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // *******************批量操作*********************
    // 翻页时的勾选回显
    restoreCheckedState() {
      /**
       * ①获取到当前数据表格中已经被选中的数据
       */
      const indexs = this.tableData
        .map((item) => {
          let flag = false;
          this.dataIds.forEach((value) => {
            value.id === item.id ? (flag = true) : "";
          });
          if (flag) {
            return item;
          }
        })
        .filter((item) => item);
      /**
       * ②回显当前数据表格中已经被勾选过的数据
       */
      this.$nextTick(() => {
        indexs.forEach((rows) => {
          this.$refs.multipleTable.toggleRowSelection(rows);
        });
      });
    },
    // 批量操作窗口
    openBatch() {
      this.isBatch = true;
    },
    // 取消批量操作
    giveUpBatch() {
      this.isBatch = false;
      this.dataIds = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 打开批量删除窗口
    openBatchDelete() {
      if (this.dataIds.length === 0)
        return this.$message.error("请至少选择一条数据");
      const ids = this.dataIds.map((item) => item.id);
      // 确认删除提示
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const req = {
            id: ids,
          };
          API.delPrompt(req).then((res) => {
            if (res.code === 200) {
              this.getList();
              this.handleClose();
              this.$message.success("批量删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message.success("取消成功");
        });
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.dataIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.dataIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      const tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.dataIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.dataIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.dataIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.dataIds = this.dataIds.concat(objArr);
      const tempDatas = new Set(this.dataIds);
      this.dataIds = Array.from(tempDatas);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
